import React from 'react';
import './style.scss';
const PREFIX = 'system-text-container';

const SystemText = ({ text }: { text: string }) => {
  return <div className={PREFIX}>
    {text}
  </div>;
};

export default SystemText;
